import { useAuth } from '@turiya/login-component';
import { TokenHandler, TuriyaRenderer } from '@turiya/orchestrator-renderer-react';
import React, { useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { API_WORKFLOW_KEY, TURIYA_ENGINE_PREFIX } from '../../common/env';
import { getEnvironment, useDataState } from '../../common/state';
import { Loading } from '../../components/Loading';
import { App } from '../../screens/app/App';
import { useClientId } from '../auth/useClientid';
import { getBusinessKeyFromToken } from '../auth/utils';

export const Orchestrator: React.FC = () => {
    const { getCurrentToken, refreshToken } = useAuth();
    const environment = useDataState(getEnvironment);
    const { isExternalUser } = useClientId();

    const tokenHandler: TokenHandler = useMemo(
        () => ({
            getToken: async (): Promise<string> => getCurrentToken() || '',
            getCurrentToken: getCurrentToken,
            refreshToken: refreshToken,
        }),
        [getCurrentToken, refreshToken],
    );

    const businessKey = getBusinessKeyFromToken(getCurrentToken() ?? '');

    return (
        <TuriyaRenderer
            engineUrl={environment.engineBaseUrl}
            customViews={{
                application: (): JSX.Element => (
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                ),
                loading: (): JSX.Element => <Loading />,
                apiLoading: (): JSX.Element => <Loading />,
                languageSwitcher: (): JSX.Element => <></>,
            }}
            containerClassNames={{
                root: 'turiya-renderer-container',
                applicationScreen: 'application-screen-view-container',
            }}
            isExternalUser={isExternalUser}
            authHandler={tokenHandler}
            prefix={{ engine: TURIYA_ENGINE_PREFIX }}
            workflowDetails={{
                applicationId: environment.appId,
                workflowKey: API_WORKFLOW_KEY,
                businessKey: businessKey,
            }}
        />
    );
};

export default Orchestrator;
